var _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5DCircle10M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "url(#paint0_linear_1_4521)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint1_linear_1_4521)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2726 59.091L21.0226 54.5455L17.6135 35.2273L40.909 26.1364L45.4544 27.2728L75.5681 14.2046L126.704 54.5455L122.727 59.091L119.318 61.3637L111.364 69.8864L73.8635 111.364L23.2953 69.8864L27.2726 59.091Z",
    fill: "url(#paint2_linear_1_4521)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4632 24.3849L41.1491 26.2861L43.2278 34.0439L25.1342 38.8921L26.7483 44.9159L26.9207 45.0674L33.4978 43.3051C38.0054 42.0973 41.5308 42.1409 44.0738 43.4359C46.6168 44.7309 48.4264 47.3864 49.5025 51.4023C50.6444 55.6641 50.1471 59.1353 48.0105 61.816C45.874 64.4967 41.9986 66.5892 36.3846 68.0935C33.7209 68.8072 31.2703 69.3321 29.0325 69.6682C27.1789 69.9114 25.4345 69.9497 23.8533 69.9845C23.4137 69.8611 23.4137 69.8611 23.4137 69.8611L21.179 68.107L21.9826 66.7152L20.9037 62.6888L20.9937 62.5329C21.9611 62.5372 23.0814 62.4566 24.3547 62.2911C25.669 62.1147 26.9982 61.9122 28.3425 61.6838C29.6758 61.4144 30.8751 61.1369 31.9406 60.8514C34.4813 60.1707 36.3948 59.5262 37.6812 58.918C38.9676 58.3097 39.7744 57.6324 40.1014 56.886C40.4584 56.0876 40.4832 55.1147 40.1758 53.9673C39.7915 52.533 39.1687 51.6019 38.3073 51.1739C37.476 50.6939 36.0563 50.7229 34.0484 51.2609L21.0897 54.6017L18.855 52.8476L19.623 51.4654L14.527 33.2356L37.8565 27.1456L39.4632 24.3849Z",
    fill: "#C195FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0489 59.9401L58.2683 61.6371L74.9096 57.1781C78.3108 56.2667 81.0875 55.2372 83.2395 54.0896C85.3806 52.901 86.9556 51.4029 87.9646 49.5954C88.9736 47.7878 89.4395 45.5108 89.3625 42.7645C89.2854 40.0181 88.7033 36.6165 87.6163 32.5596C86.5732 28.6666 85.4149 25.5731 84.1414 23.2791C82.8569 20.9441 78.1748 15.1886 74.8425 13.7286C74.9895 14.2774 75.6961 16.7579 73.2585 16.84C70.81 16.8812 67.8851 17.3575 64.4839 18.2688L47.4573 22.8311L56.7691 58.1758L56.0489 59.9401ZM65.2936 26.9458L59.5156 28.494L65.4944 50.8069L71.2724 49.2587C73.6491 48.6219 75.4423 47.8559 76.6518 46.9608C77.9024 46.0548 78.5949 44.7053 78.7294 42.9125C78.9048 41.1086 78.5479 38.5471 77.6585 35.2278C76.813 32.0724 75.8798 29.819 74.8588 28.4675C73.8679 27.064 72.6099 26.3031 71.0849 26.1847C69.6008 26.0553 67.6704 26.309 65.2936 26.9458Z",
    fill: "#C195FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0489 59.9401L52.9713 57.2354L55.0832 56.2746L45.7714 20.93L62.798 16.3677C66.1993 15.4564 69.1241 14.9801 71.5727 14.9389C74.0102 14.8567 74.2937 13.8757 74.1466 13.3269C77.4789 14.7869 81.171 19.043 82.4555 21.378C83.729 23.672 84.8873 26.7655 85.9304 30.6585C87.0175 34.7154 87.5995 38.117 87.6766 40.8633C87.7537 43.6097 87.2877 45.8867 86.2787 47.6942C85.2698 49.5018 83.6947 50.9999 81.5537 52.1885C79.4016 53.3361 76.625 54.3656 73.2237 55.2769L56.0489 59.9401ZM57.8298 26.5929L63.6077 25.0447C65.9845 24.4079 67.9149 24.1541 69.399 24.2835C70.924 24.402 72.182 25.1629 73.173 26.5664C74.1939 27.9179 75.1271 30.1713 75.9726 33.3267C76.862 36.6459 77.219 39.2075 77.0435 41.0113C76.909 42.8042 76.2165 44.1537 74.9659 45.0597C73.7564 45.9548 71.9632 46.7207 69.5865 47.3576L63.8085 48.9058L57.8298 26.5929Z",
    fill: "#5709C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4634 24.3849L36.2387 21.1314L36.1708 25.2444L12.8413 31.3344L17.9373 49.5642L15.7775 50.1429L18.8551 52.8476L32.3627 49.3598C34.3706 48.8217 35.7903 48.7927 36.6216 49.2727C37.4829 49.7007 38.1058 50.6318 38.4901 52.0661C38.7975 53.2135 38.7727 54.1864 38.4157 54.9848C38.0886 55.7312 37.2819 56.4086 35.9955 57.0168C34.7091 57.625 32.7955 58.2695 30.2549 58.9503C29.1894 59.2358 27.9901 59.5132 26.6568 59.7826C25.3125 60.011 23.9833 60.2135 22.669 60.39C21.3957 60.5555 20.2754 60.636 19.308 60.6317L19.218 60.7876L20.2968 64.814L18.1015 65.4023L21.1792 68.107C21.5008 68.0979 21.8304 68.0907 22.1675 68.0833C23.7487 68.0486 25.4931 68.0102 27.3468 67.767C29.5845 67.4309 32.0352 66.906 34.6988 66.1923C40.3129 64.688 44.1882 62.5955 46.3248 59.9148C48.4614 57.2341 48.9587 53.7629 47.8167 49.5011C46.7407 45.4852 44.9311 42.8297 42.3881 41.5347C39.845 40.2397 36.3197 40.1961 31.812 41.4039L25.235 43.1662L25.0626 43.0148L23.4485 36.9909L41.5421 32.1427L39.4634 24.3849Z",
    fill: "#5709C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9713 57.2354L42.5303 18.269L59.7198 13.6631C63.1211 12.7518 66.046 12.2755 68.4945 12.2343C70.932 12.1521 73.0341 12.621 74.8007 13.641C76.5673 14.6609 78.0928 16.3384 79.3773 18.6734C80.6508 20.9674 81.8091 24.0609 82.8522 27.9539C83.9393 32.0107 84.5213 35.4124 84.5984 38.1587C84.6755 40.9051 84.2095 43.1821 83.2006 44.9896C82.1916 46.7972 80.6166 48.2953 78.4755 49.4839C76.3234 50.6315 73.5468 51.661 70.1455 52.5724L52.9713 57.2354ZM60.5296 22.3401L54.7516 23.8883L60.7303 46.2012L66.5083 44.653C68.885 44.0161 70.6782 43.2502 71.8878 42.3551C73.1383 41.4491 73.8308 40.0996 73.9653 38.3067C74.1408 36.5029 73.7838 33.9413 72.8944 30.6221C72.0489 27.4667 71.1157 25.2133 70.0948 23.8618C69.1038 22.4583 67.8458 21.6973 66.3208 21.5789C64.8367 21.4495 62.9063 21.7033 60.5296 22.3401Z",
    fill: "url(#paint3_linear_1_4521)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7773 50.1425L9.895 28.1897L36.2384 21.131L38.5653 29.411L20.3707 34.2862L21.9848 40.31L22.1572 40.4615L28.7343 38.6992C33.2419 37.4914 36.7673 37.535 39.3103 38.83C41.8533 40.125 43.6629 42.7805 44.739 46.7964C45.8809 51.0582 45.3836 54.5294 43.247 57.2101C41.1105 59.8908 37.2351 61.9833 31.6211 63.4876C28.9574 64.2013 26.5068 64.7262 24.269 65.0623C22.0203 65.3574 19.9322 65.3505 18.1013 65.4019L16.1402 58.0829L16.2302 57.927C17.1976 57.9313 18.3179 57.8507 19.5912 57.6852C20.9055 57.5088 22.2347 57.3063 23.579 57.0779C24.9123 56.8085 26.1116 56.531 27.1771 56.2455C29.7178 55.5648 31.6313 54.9203 32.9177 54.3121C34.2041 53.7038 35.0109 53.0265 35.3379 52.2801C35.6949 51.4817 35.7197 50.5088 35.4123 49.3614C35.028 47.9271 34.4052 46.996 33.5438 46.5679C32.7125 46.088 31.2928 46.117 29.2849 46.655L15.7773 50.1425Z",
    fill: "url(#paint4_linear_1_4521)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0557 76.5508L60.2288 64.7727L56.4018 76.5508L47.882 76.6592L44.3181 74.4318V76.7045L54.0366 83.8301L51.5347 92.2153L50.5681 93.1818V95.4545L60.2288 88.3289L69.8863 95.4545V93.1818L68.921 92.2165L66.4209 83.8301L76.7045 76.7045V74.4318L71.0227 76.1363L72.0458 76.6479L64.0557 76.5508Z",
    fill: "#DA7108"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.879 62.3468L63.7059 74.1249L76.7045 74.4318L66.0711 81.4042L69.8863 93.1818L59.879 85.903L50.5681 93.1818L53.6869 81.4042L44.3181 74.4318L56.052 74.1249L59.879 62.3468Z",
    fill: "#F4D32D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4439 60.9907L85.386 53.8488L83.662 61.4241L78.3453 61.9743L75.9926 60.7845L76.1213 62.2044L82.5966 66.1059L81.5083 71.4863L80.9592 72.1449L81.0879 73.5648L86.72 68.5659L93.1572 72.4708L93.0285 71.0509L92.3707 70.5025L90.3338 65.4046L96.3551 60.3704L96.2264 58.9505L92.7731 60.3372L93.4413 60.5988L88.4439 60.9907Z",
    fill: "#DA7108"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0305 52.3529L88.0884 59.4947L96.2268 58.9503L89.9783 63.9086L93.0289 71.0508L86.3645 67.07L80.9596 72.1448L82.2411 64.6099L75.993 60.7844L83.3065 59.9282L85.0305 52.3529Z",
    fill: "#F4D32D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3221 79.054L29.1014 83.1427L34.1185 81.8121L30.819 85.6697L33.5937 89.7595L28.9465 88.0841L26.1882 91.9117L26.0716 87.0494L21.7033 85.4203L26.1673 83.9954L26.3221 79.054Z",
    fill: "#F4DE6C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2273 62.5H7.95459L13.6364 69.3182L10.2273 62.5Z",
    fill: "#F4DE6C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6435 11.0282L36.3715 11.9961C35.9525 12.091 35.7799 12.5937 36.0522 12.926C36.1836 13.0864 36.391 13.1641 36.5954 13.1296L40.9145 12.4002C41.4885 12.3033 41.6998 11.5886 41.271 11.1951C41.1018 11.0399 40.8673 10.9775 40.6435 11.0282Z",
    fill: "#72FBBF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4521",
    x1: 20.7854,
    y1: 0.00000146234,
    x2: 79.2146,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B785FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7143DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4521",
    x1: 20.7854,
    y1: 0.00000146234,
    x2: 79.2146,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F9CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A89E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4521",
    x1: 26.1639,
    y1: 14.2046,
    x2: 96.5289,
    y2: 74.3264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6E40BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E40BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4521",
    x1: 44.0048,
    y1: 20.1705,
    x2: 52.24,
    y2: 50.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_4521",
    x1: 44.0047,
    y1: 20.1702,
    x2: 52.2399,
    y2: 50.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#F6EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6BAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5DCircle10M);
export default __webpack_public_path__ + "static/media/5d_circle_10m.f6b344a04a532eeb8bb7c8a2a11295bb.svg";
export { ForwardRef as ReactComponent };